function abort(working, command, p) {
  working.abort = true;
  return working.text;
}
abort.key = "abort";
abort.title = "Abort";
abort.category = "Flow Control";
abort.docUrl = "https://deanebarker.net/tech/code/textflow-js/commands/abort/";
abort.description =
  "Abort the pipeline immediately, discarding any partial results.";
abort.args = [];
abort.passthrough = true;

export default abort;
